/**
 * AI Recruit - Question Complexity Level API Service
 * CRUD for the complexity levels proctored interview questions are pitched at.
 */

import { apiV2 } from './api'

export interface ComplexityLevel {
  id: string
  name: string
  description?: string | null
  is_active: boolean
  display_order: number
  created_at: string
  updated_at: string
}

export const fetchComplexityLevels = async (): Promise<ComplexityLevel[]> => {
  const response = await apiV2.get<ComplexityLevel[]>('/complexity-levels')
  return response.data
}

export const createComplexityLevel = async (data: { name: string; description?: string }): Promise<ComplexityLevel> => {
  const response = await apiV2.post<ComplexityLevel>('/complexity-levels', data)
  return response.data
}

export const updateComplexityLevel = async (
  levelId: string,
  data: Partial<{ name: string; description: string; display_order: number }>
): Promise<ComplexityLevel> => {
  const response = await apiV2.put<ComplexityLevel>(`/complexity-levels/${levelId}`, data)
  return response.data
}

export const deleteComplexityLevel = async (levelId: string): Promise<void> => {
  await apiV2.delete(`/complexity-levels/${levelId}`)
}
